import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Fragment } from "react";
import { AddAbsenceModal } from "@/modals/users/add-absence-modal";

export function AbsencesMenu() {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<div className="h-stack gap-4">
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={disclosure.onOpen}
				>
					{t("absences.add_absence")}
				</Button>
			</div>
			<AddAbsenceModal
				isOpen={disclosure.isOpen}
				onClose={disclosure.onClose}
			/>
		</Fragment>
	);
}
